export enum StockPrices {
  RESALE_PRICE = 'resalePrice',
  ASKING_PRICE = 'askingPrice',
  EFFECTIVE_TRADE_IN_PRICE = 'effectiveTradeInPrice',
  SOLD_PRICE = 'soldPrice',
}
